// extracted by mini-css-extract-plugin
export default {"root":"styles_root__eq2Gl","title":"styles_title__LBCDF"};